import { useEffect, useState } from "react";
import DashboardLayout from '../Layout/Index'
import { Select } from '@headlessui/react'
import { FaNairaSign } from "react-icons/fa6";
import { TiSpanner } from "react-icons/ti";
import { IoMdBicycle } from "react-icons/io";
import { TbStarHalfFilled } from "react-icons/tb";
import { BsBoxSeam } from "react-icons/bs";
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';
import { useDispatch, useSelector } from "react-redux";
import { fetchNotification } from "../redux/slices/notificationSlice";
import Loader from "../components/Loader";
import { NotificationType } from "../utils/Enums";
import { SelectDropDown } from "../components/SelectDropdown";

const Report = () => {
  const itemsPerPage = 10;
  
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1); 
  const [totalRecord, setTotalRecord] = useState(0);
  const [notificationType, setNotificationType] = useState(null);

  const notification = useSelector((state) => state); 

  useEffect(() =>{
    dispatch(
      fetchNotification({
      searchText: searchTerm,
      pageSize: itemsPerPage,
      pageNumber: currentPage,
      notificationType: notificationType,

    }))
  }, [dispatch, searchTerm, currentPage, notificationType]);

  const SelectedOption = [
    { label: "New Order", value: "1" },
    { label: "Order Sent", value: "2" },
    { label: "Order Picked", value: "3" },
    { label: "Order Delivered", value: "4" },
    { label: "Received Payment", value: "5" },
    { label: "Initialized Payment", value: "6" },
    { label: "Assign Agent", value: "7" },
    { label: "Change OrderStatus", value: "8" },
  ];

  useEffect(() => {
    if(notification) {
      setTotalRecord(notification?.notification?.notification?.totalRecord);
    }
  },[notification]);

  const totalPages = Math.ceil(totalRecord / itemsPerPage);

  const notificationData = notification?.notification?.notification?.data;

  const changeNotificationStatus = (selectedOption) => {
    setNotificationType(selectedOption.value);
  }

  return (
    <DashboardLayout>
      <div className="px-6 sm:px-8 pt-5 py-10 bg-white w-full mt-16">
        <div className="bg-white px-2 py-3">
          <h1 className="text-2xl font-bold text-primaryRed pb-2">Notifications</h1>
          <p className="text-sm text-[#0A0A0A]/80">
            Get real-time updates on orders, customer feedback, and system alerts to keep operations smooth. Review notifications to stay proactive and address any issues swiftly.
          </p>
        </div>
        <div className='rounded-lg border py-10 px-6'>
          <div className='flex justify-between items-center pb-6'>
            <div className="flex items-center gap-3">
              <p className="text-sm">Page</p>
              <ResponsivePagination
                current={currentPage}
                total={totalPages}
                onPageChange={setCurrentPage}
                extraClassName="custom-pagination"
              />
            </div>
            <div>
            <SelectDropDown 
              onSelect={changeNotificationStatus}
              options={SelectedOption}
            />
          </div>
          </div>
          <div className="mt-5">
            {loading ? (
              <Loader />
            ) : notificationData?.length > 0 ?
             (notificationData.map((notification) =>(
              <div key={notification?.id}>
                <div className="">
                  <div className="flex justify-between items-center gap-2">
                    <div className="flex items-center gap-4">
                      <span className={`flex items-center justify-center h-8 w-8 rounded-full ${
                          NotificationType[notification.notificationType] === "New Order" ||
                          NotificationType[notification.notificationType] === "Order Sent" ||
                          NotificationType[notification.notificationType] === "Order Picked" ||
                          NotificationType[notification.notificationType] === "Order Delivered"
                            ? "bg-[#FFF6E6] border border-[#FFE3B0]"
                            : NotificationType[notification.notificationType] === "Received Payment" ||
                              NotificationType[notification.notificationType] === "Initialized Payment"
                            ? "bg-[#E6F2E6] border border-[#B0D8B0]"
                            : NotificationType[notification.notificationType] === "Assign Agent" ||
                              NotificationType[notification.notificationType] === "Change OrderStatus"
                            ? "bg-[#F2E6F2] border border-[#D8B0D8]"
                            : "bg-[#EDF4FC] border border-[#C7DDF6]"
                        }`}
                      >
                        {
                          NotificationType[notification.notificationType] === "New Order" ? <BsBoxSeam className='text-orange' />  : 
                          NotificationType[notification.notificationType] === "Order Sent" ? <BsBoxSeam className='text-orange' /> : 
                          NotificationType[notification.notificationType] === "Order Picked" ? <BsBoxSeam className='text-orange' /> : 
                          NotificationType[notification.notificationType] ===  "Order Delivered"? <BsBoxSeam className='text-orange' /> : 
                          NotificationType[notification.notificationType] === "Received Payment" ? <FaNairaSign className='text-[#008000]' /> : 
                          NotificationType[notification.notificationType] ===  "Initialized Payment" ? <FaNairaSign className='text-[#008000]' /> : 
                          NotificationType[notification.notificationType] === "Assign Agent" ? <IoMdBicycle className='text-[#800080]' /> : 
                          NotificationType[notification.notificationType] === "Change OrderStatus" ? <IoMdBicycle className='text-[#800080]' /> : 
                          <TiSpanner className='text-[#4A90E2]' /> }
                      </span>
                      <p className={`text-md font-semibold capitalize 
                         ${
                          NotificationType[notification.notificationType] === "New Order" ? 'text-orange' : 
                          NotificationType[notification.notificationType] === "Order Sent" ? 'text-orange' : 
                          NotificationType[notification.notificationType] === "Order Picked" ? 'text-orange' : 
                          NotificationType[notification.notificationType] === "Order Delivered" ? 'text-orange' : 
                          NotificationType[notification.notificationType] === "Received Payment" ? 'text-[#008000]' : 
                          NotificationType[notification.notificationType] === "Initialized Payment" ? 'text-[#008000]' : 
                          NotificationType[notification.notificationType] === "Assign Agent" ? 'text-[#800080]' : 
                          NotificationType[notification.notificationType] === "Change OrderStatus" ? 'text-[#800080]' : 
                          'text-[#4A90E2]'
                         }
                         ` }>
                          {notification?.title}
                        </p>
                    </div>
                    <p className="text-sm">{notification?.duration}</p>
                  </div>
                  <div className="flex justify-between items-center">
                    <div className="mt-3 max-w-3xl">
                      <p className="text-sm pl-10 text-[#0A0A0A]/80">{notification?.message}</p>
                    </div>
                    {/* <button className="text-sm bg-primaryRed text-Red py-1.5 rounded-md text-white px-3 capitalize whitespace-nowrap"></button> */}
                  </div>
                </div>
                <div className="h-[1px] w-full border-0 bg-primaryGray my-3" />
              </div>
            )))
            : <p className="text-center text-primaryRed">No Notification</p>
            }
          </div>
        </div>
      </div>
    </DashboardLayout>
  )
}

export default Report